import { FunctionComponent } from 'react'
import {
  Box,
  Button,
  TableCell,
  TableRow,
  Typography,
  rucksack,
} from '@black-bear-energy/rucksack'
import {
  DocumentRequirement,
  DocumentRequirementsChecklist,
} from '@black-bear-energy/black-bear-energy-common'
import { FilesPreviewMenu } from 'components/common/FilesPreviewMenu'
import { UploadStatusChip } from './UploadStatusChip'
import { ReviewStatusIcon } from './ReviewStatusIcon'

type DocumentRequirementRowProps = DocumentRow | ChecklistRow

interface DocumentRow {
  requirement: DocumentRequirement
  depth: number
  isLeaf: true
}

interface ChecklistRow {
  requirement: DocumentRequirementsChecklist
  depth: number
  isLeaf: false
}

export const DocumentRequirementRow: FunctionComponent<
  DocumentRequirementRowProps
> = ({ requirement, depth, isLeaf }) => {
  return (
    <TableRow className={requirement.defaultHidden ? 'VerifiedRow' : ''}>
      <TableCell>
        <Typography
          variant="body2"
          sx={{
            color: isLeaf
              ? rucksack.palette.text.primary
              : rucksack.palette.text.secondary,
            marginLeft: `${depth * 16}px`,
          }}
        >
          {requirement.name}
        </Typography>
      </TableCell>
      <TableCell>
        {isLeaf ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <UploadStatusChip document={requirement} />
          </Box>
        ) : (
          <></>
        )}
      </TableCell>
      <TableCell>
        {isLeaf ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <ReviewStatusIcon document={requirement} />
          </Box>
        ) : (
          <></>
        )}
      </TableCell>
      <TableCell
        sx={{
          '&.MuiTableCell-root': {
            paddingY: isLeaf && requirement.uploaded ? '2px' : 'unset',
          },
        }}
      >
        {isLeaf && requirement.uploaded ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <FilesPreviewMenu
              documentId={requirement.id}
              documentName={requirement.name}
            >
              <Button
                sx={{
                  fontSize: '13px',
                  height: '30px',
                  paddingY: '4px',
                  // Override the pink hover and focus color defined in index.css.
                  '&:hover, &:focus': {
                    color: rucksack.palette.primary.main,
                  },
                }}
              >
                View
              </Button>
            </FilesPreviewMenu>
          </Box>
        ) : (
          <></>
        )}
      </TableCell>
    </TableRow>
  )
}

DocumentRequirementRow.displayName = 'DocumentRequirementRow'
